module.exports = __webpack_public_path__ + "static/media/arrowBack.bee21589.svg";